<template>
  <quiz-layout class="quiz-item">
    <template v-slot:active>{{ active + 1 }}</template>
    <template v-slot:length>{{ total }}</template>

    <h2 class="quiz-item__title">
      {{ item.title }}
    </h2>

    <template v-if="hasAnswer">
      <quiz-answer class="quiz-item__answer" v-for="(option, optionIndex) in item.options" :key="`option-${optionIndex}`" :isSelected="mutableAnswer === option.id" :isCorrect="option.isAnswer" :item="option" :answer="item.answer" />
    </template>

    <template v-else>
      <div class="quiz-item__option" v-for="(option, optionIndex) in item.options" :key="`option-${optionIndex}`">
        <form-check  :label="option.text" :id="`idOption${index}-${optionIndex}`">
          <input type="radio" v-model="mutableAnswer" :value="option.id" :id="`idOption${index}-${optionIndex}`" />
        </form-check>
      </div>
    </template>

    <template v-slot:footer>
      <button v-if="!hasAnswer" type="button" class="btn btn-secondary" :disabled="mutableAnswer === null" @click="onSelect">Проверить ответ</button>

      <button v-else-if="(active + 1) === total" class="btn btn-secondary" @click="onFinish">Показать результаты теста</button>

      <button v-else type="button" class="btn btn-secondary" @click="onNext">
        Следующий вопрос
        <icon class="btn-secondary__icon" name="arrowNext" width="24" height="14" />
      </button>
    </template>

    <template v-slot:image>
      <img class="quiz-layout__image" :src="picture">
    </template>
  </quiz-layout>
</template>

<script>
import QuizLayout from './QuizLayout'
import QuizAnswer from './QuizAnswer'
import FormCheck from '../shared/FormCheck'
import Icon from '../shared/Icon'
// assets
import QuizPicture from '../../assets/image/quiz_picture@2x.jpg'

export default {
  components: {
    QuizLayout,
    QuizAnswer,
    FormCheck,
    Icon
  },
  props: {
    item: Object,
    active: Number,
    index: Number,
    total: Number,
    hasAnswer: Boolean
  },
  data () {
    return {
      mutableAnswer: null,
      picture: QuizPicture
    }
  },
  computed: {
    isCorrect () {
      return this.mutableAnswer === this.item.answer.id
    }
  },
  methods: {
    onSelect () {
      this.$emit('select', { index: this.index, value: this.isCorrect })
    },
    onNext () {
      this.$emit('next')
    },
    onFinish () {
      this.$emit('finish')
    }
  }
}
</script>

<style lang="scss" scoped>
.quiz-item {
  &__title {
    @include font-size(24px);

    color: $theme-red-100;
    margin-bottom: 20px;
  }

  &__option {
    & + & {
      margin-top: 7px;
    }
  }

  &__answer {
    & + & {
      margin-top: 15px;
    }
  }
}
</style>
